import http from './http'

class ExportExcel {
  download(payload) {
    return http.post(payload.path, { params: payload.data }, { responseType: 'blob' })
  }
}

export default new ExportExcel()
